<template>
  <b-field
    :class="{
      'obligatoire': required,
    }"
    :type="type"
    :label="label"
    :message="message">
    <b-autocomplete
      :value="name"
      icon="magnify"
      :open-on-focus="openOnFocus"
      :data="filteredItems"
      :field="field"
      :placeholder="$i18n.t('general.autocomplete.search')"
      :loading="isFetching"
      :disabled="disabled"
      :clearable="clearable"
      :expanded="expanded"
      @input="setName"
      @select="select">
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
      <template slot="empty">
        <div v-if="!isFetching">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>
          {{$t('general.autocomplete.search')}}
        </div>
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    target: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: false,
      default: 'libelle',
    },
    selector: {
      type: String,
      required: false,
      default: 'id',
    },
    openOnFocus: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Function,
      required: false,
      default: null,
    },
    customMapItem: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      isFetching: false,
      name: '',
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    filteredItems() {
      return this.items.filter(item => {
        return (this.selected === item.id || item.actif)
        && (this.name === '' || item[this.field].toLowerCase().includes(this.name?.trim().toLowerCase()))
        && (this.query ? this.query(item) : true);
      });
    },
    currentItem() {
      return this.items.find(i => i[this.selector] === this.selected);
    },
    message() {
      return (this.currentItem && !this.currentItem?.actif) ? this.$t('general.messages.warning.archive') : '';
    },
    type() {
      return (this.currentItem && !this.currentItem?.actif) ? 'is-warning' : '';
    },
  },
  watch: {
    // pour le cas où la valeur change hors de l'autocomplete
    selected(newValue) {
      this.name = this.items.find(i => i[this.selector] === newValue)?.[this.field] ?? '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    setName(value) {
      const existingItem = this.items.find(i => i[this.field] === value);
      if (!existingItem) this.selected = null;
      this.name = value;
    },
    select(value) {
      this.$emit('select', value);
      if (!value) {
        this.selected = null;
        return;
      }
      this.selected = value[this.selector];
    },
  },
  async mounted() {
    try {
      this.isFetching = true;
      await this.loadParametres([this.target]);
      if (this.customMapItem) {
        this.items = this.parametre(this.target).map(this.customMapItem);
      } else {
        this.items = this.parametre(this.target);
      }

      this.name = this.currentItem?.[this.field] ?? '';

      // en attendant que l'archivage arrive sur tous les cas d'utilisation
      this.items.forEach(i => {
        if (i.actif === undefined) {
          i.actif = true;
        }
      });

      this.isFetching = false;
    } catch (e) {
      messageErreur(this.$i18n);
    }
  },
};
</script>

<style>

</style>
